// extracted by mini-css-extract-plugin
module.exports = {"title":"withVistoo_title__2GcbC","content":"withVistoo_content__2jDUz","firstText":"withVistoo_firstText__3cB9i","text":"withVistoo_text__1a0fn","lastText":"withVistoo_lastText__ADvKX"};
    if(module.hot) {
      // 1790670309671
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  